"use client"

import { useEffect } from "react"
import { AlertCircle, RefreshCw, Home } from "lucide-react"

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        // Log client exception details for debugging
        console.error("[Deckwale Client Error]:", error)
    }, [error])

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
            <div className="max-w-md w-full bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-slate-200 text-center">
                <div className="w-14 h-14 bg-red-50 text-red-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <AlertCircle className="w-7 h-7" />
                </div>

                <h2 className="text-xl font-semibold text-slate-900 mb-2">
                    Something went wrong
                </h2>

                <p className="text-sm text-slate-500 mb-6 leading-relaxed">
                    An unexpected error occurred while loading this view. You can try refreshing the component or return to the dashboard.
                </p>

                <div className="flex flex-col sm:flex-row items-center gap-3 justify-center">
                    <button
                        type="button"
                        onClick={() => reset()}
                        className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-slate-900 text-white text-sm font-medium rounded-xl hover:bg-slate-800 transition-colors shadow-sm"
                    >
                        <RefreshCw className="w-4 h-4" />
                        Try again
                    </button>

                    <button
                        type="button"
                        onClick={() => window.location.href = "/home"}
                        className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-white text-slate-700 text-sm font-medium rounded-xl border border-slate-200 hover:bg-slate-50 transition-colors"
                    >
                        <Home className="w-4 h-4" />
                        Go to Home
                    </button>
                </div>
            </div>
        </div>
    )
}
